import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from './auth.service'

/**
 * Blocks every store-shaped route for an account that has not created its
 * first store yet.
 *
 * Signup mints an identity and nothing else — naming the store and picking its
 * currency are the first onboarding step. Until that step runs there is no
 * store id on the session, so the dashboard (and the plan/paywall screen, which
 * prices a store) have nothing to render. Anyone who lands on one — a deep
 * link, a bookmark, the post-login `/home` navigation — is sent to the wizard.
 *
 * Runs after AuthGuard, so the session is already hydrated.
 */
export const storeGuard: CanActivateFn = () => {
  const auth = inject(AuthService)
  const router = inject(Router)

  return auth.hasStore() ? true : router.parseUrl('/welcome')
}
